import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router/routes";
import Antd from 'ant-design-vue'

const app = createApp(App)
app.use(router) // 挂载路由
app.use(Antd)

app.mount('#app')

